export enum ECouponType {
  COUFR = 'COUFR',
  COUFA = 'COUFA',
  COUFF = 'COUFF',
  COULC = 'COULC',
}
